module.exports = __webpack_public_path__ + "static/img/fastbi_suit.5c175e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/fastbi_suit.png
// module id = GiVC
// module chunks = 1